import styled from "styled-components";

export const DownloadsDiv = styled.div`
  h1 {
    text-align: center;
    margin: 1rem 0;
  }

  a {
    text-decoration: none;
  }

  ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  .card {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    padding: 1rem;
    max-width: max-content;
    list-style: none;
    border-radius: 8px;
    box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0,
      rgba(60, 64, 67, 0.15) 0 2px 6px 2px;
  }
`;
